import React, { useMemo } from 'react';
import { Box } from '@mui/material';
import { useLocale } from '../../contexts/LocaleContext';
import {
  buildTransportLrBodyHtml,
  LR_PRINT_STYLES,
  TransportLrPrintOptions,
} from '../../utils/transportLrPrintHtml';

interface BiltyPrintProps {
  bilty: Record<string, any>;
  company?: Record<string, any> | null;
  printOptions?: TransportLrPrintOptions;
}

export const BiltyPrint: React.FC<BiltyPrintProps> = ({ bilty, company, printOptions }) => {
  const { formatCurrency, formatDate } = useLocale();
  const bodyHtml = useMemo(
    () => buildTransportLrBodyHtml(bilty, company, { formatCurrency, formatDate }, printOptions),
    [bilty, company, formatCurrency, formatDate, printOptions],
  );

  return (
    <Box
      id="bilty-print"
      sx={{
        bgcolor: '#fff',
        maxWidth: 860,
        mx: 'auto',
        '@media print': { maxWidth: '100%' },
      }}
    >
      <style>{LR_PRINT_STYLES.replace(/body\s*\{[^}]+\}/, '')}</style>
      <Box dangerouslySetInnerHTML={{ __html: bodyHtml }} />
    </Box>
  );
};

export { openTransportLrPrintWindow as printBilty } from '../../utils/transportLrPrintHtml';
